import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

//TODO import store and use dispatch directly
//TODO combine this screen with Kaiser Info
@connect((store) => {
    return { gender: store.user.gender };
})
class Kaiser extends React.Component {
    constructor(props) {
        super(props);
        this.goToKaiserInfo = this.goToKaiserInfo.bind(this);
    }

    goToKaiserInfo() {
        this.props.history.push('/location?id=kaiser');
    }
    
    render() {
        let titleText;

        if (this.props.gender === 'female') {
            titleText = 'You can get EC for free!';
        } else {
            titleText = 'Kaiser Permanente $25';
        }

        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <h1 className="ec__font__title text-center">{titleText}</h1>
                        <p className="ec__font__body text-center">Here's what you need to do:</p>

                        <ul className="ec__text-list ec__text-list--blue ">
                            <li>
                                <p> 1. Call Kaiser (info below).</p>
                            </li>
                            <li>
                                <p> 2. Follow phone instructions.</p>
                            </li>
                            <li>
                                <p>
                                    3. Ask for a doctor's prescription for emergency contraception to be sent to the pharmacy.
                                </p>
                            </li>
                            <li>
                                <p>
                                    4. Ask for this prescription to be <b>confidential</b> if you need it to stay private.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="row">
                    <div className="choices col text-center">
                        <button className="ec__button" onClick={this.goToKaiserInfo}>See Kaiser Info</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Kaiser;


// WEBPACK FOOTER //
// ./src/components/screens/Kaiser.js